import styled from "styled-components";
import type { GlobalToken } from "antd";
import { radius } from "@libertify/ui";

/**
 * Numbered badge for a document's position in the source-file list. Index 0 is
 * the primary document (filled accent); the rest are neutral. Shared by the
 * Step-1 sidebar and the customize-view Documents card so the two lists read
 * the same.
 */
export const OrderNumber = styled.span<{
  $token: GlobalToken;
  $isMain: boolean;
}>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  flex-shrink: 0;
  border-radius: ${radius.circle};
  font-size: ${({ $token }) => $token.fontSizeSM}px;
  font-weight: 600;
  color: ${({ $token, $isMain }) =>
    $isMain ? $token.colorWhite : $token.colorTextSecondary};
  background: ${({ $token, $isMain }) =>
    $isMain ? $token.colorPrimary : $token.colorFillSecondary};
`;
